import React from "react";
import { useEffect, useState, createContext, useRef } from 'react';
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";

export const ReversasUUIDVigente = ({ data }) => {
    const [reversas, setReversas] = useState([]);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });


    useEffect(() => {
        setReversas(data)
    }, [data]);

    return (
        <div className="listado-fiscal-invoicemovimientos-container">
            <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
                <table className="grande">
                    <thead>
                        <tr>
                            {/* <th>
                                ID
                            </th> */}
                            <th>
                                Documento
                            </th>
                            <th>
                                <div>Cust. Ord. No.</div>
                            </th>
                            <th>
                                <div>Fecha</div>
                            </th>
                            <th>
                                <div>Ro. Number</div>
                            </th>
                            <th>
                                <div>Special Inst.</div>
                            </th>
                            <th>
                                <div>Serie Fiscal</div>
                            </th>
                            <th>
                                <div>Folio Fiscal</div>
                            </th>
                            <th>
                                <div>Batch</div>
                            </th>
                            <th>
                                <div>UUID</div>
                            </th>
                            <th>
                                <div>RFC</div>
                            </th>
                            <th>
                                <div>Tipo de Comprobante</div>
                            </th>
                            <th>
                                <div>Condición de pago</div>
                            </th>
                            <th>
                                <div>Cancelado</div>
                            </th>
                            <th>
                                <div>Fecha de cancelación</div>
                            </th>
                            <th>
                                <div>Importe</div>
                            </th>
                            <th>
                                <div>Batch de Cancelación</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {reversas.map((rev) => (
                            <tr>
                                <td className="ta-center">{rev.document_no}</td>
                                <td className="ta-center">{rev.cust_ord_no}</td>
                                <td className="ta-center">{new Date(rev.invo_date).toLocaleDateString("es-MX", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric"
                                })}</td>
                                <td className="ta-center">{rev.ro_number}</td>
                                <td className="ta-center">{rev.special_inst}</td>
                                <td className="ta-center">{rev.series_code}</td>
                                <td className="ta-center">{rev.fiscal_document_no}</td>
                                <td className="ta-center">{rev.batch}</td>
                                <td className="ta-center">{rev.uuid}</td>
                                <td className="ta-center">{rev.rfc}</td>
                                <td className="ta-center">{capitalizePalabras(rev.tipoComprobante)}</td>
                                <td className="ta-center">{capitalizePalabras(rev.condicionPago)}</td>
                                <td className="ta-center">{rev.cancelado ? "Si" : "No"}</td>
                                <td className="ta-center">{rev.fechaCancelacion ? new Date(rev.fechaCancelacion).toLocaleDateString("es-MX", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric"
                                }) : ""}</td>
                                <td className="ta-right">{FormatMoney(rev.total)}</td>
                                <td className="ta-center">{rev.batch_cancelacion}</td>
                                
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
